import React from 'react'
import { useSelector } from 'react-redux'
import { isEmpty } from 'lodash'

import { Pill } from '@/components/pills/Pill'

import { ScorecardCriteriaSummaryTable } from '../components/ScorecardCriteriaSummaryTable'
import { sortCriteriaByPlaybookSections } from '../helpers/index'

import './ViewScorecardSummary.scss'

const SECTION_TITLES = {
  Deck: 'Dynamic Prompts',
}

export const MeasureSummary = ({ measure }) => {
  const { data } = useSelector((state) => state.scorecards)
  const { targetPlaybook } = data
  const criteriaByPlaybookSection = sortCriteriaByPlaybookSections(measure, targetPlaybook.body)

  const columns = [
    { label: 'Name', accessor: 'name' },
    { label: 'Present or Not?', accessor: 'must_be_present' },
  ]

  if (measure.condition_type === 'AND') {
    columns.push({ label: 'Weight', accessor: 'weight' })
  }

  return (
    <div className="scorecard-summary__measure-summary" data-testid="measure-summary">
      <div className="scorecard-summary__measure-summary-header">
        <h3>{measure.name}</h3>
        {measure.auto_fail && (
          <Pill small critical>
            Auto-fail
          </Pill>
        )}
        {measure.auto_zero && (
          <Pill small caution>
            Auto-zero
          </Pill>
        )}
      </div>
      {criteriaByPlaybookSection.map((playbookSection) => (
        <section key={playbookSection.sectionName}>
          <h4>{SECTION_TITLES[playbookSection.sectionName] || playbookSection.sectionName}</h4>
          <ScorecardCriteriaSummaryTable columns={columns} rows={playbookSection.criteria} />
        </section>
      ))}
    </div>
  )
}

export const EmptySection = () => {
  return (
    <div className="scorecard-summary__empty-section" data-testid="empty-section">
      No items selected
    </div>
  )
}

export const SectionSummary = ({ section }) => {
  const sectionHasCriteria = section.measures.some((measure) => measure.criteria.length > 0)
  if (!sectionHasCriteria) {
    return (
      <div className="scorecard-summary__empty-section-container">
        <h2 className="scorecard-summary__section-title">{section.name}</h2>
        <EmptySection />
      </div>
    )
  }

  return (
    <div className="scorecard-summary__section-summary" data-testid="section-summary">
      <h2 className="scorecard-summary__section-title">{section.name}</h2>
      <div className="scorecard-summary__measure-container">
        {section.measures.map((measure) => {
          if (measure.criteria.length) {
            return <MeasureSummary measure={measure} key={measure.name} />
          }
          return null
        })}
      </div>
    </div>
  )
}

export const ViewScorecardSummary = ({ scorecardConfig = {} }) => {
  return (
    <div>
      <div className="scorecard-summary" data-testid="view-scorecard-summary">
        {!isEmpty(scorecardConfig.sections) &&
          scorecardConfig.sections.map((section) => (
            <SectionSummary section={section} key={section.name} />
          ))}
      </div>
    </div>
  )
}
